import * as cmmn from '@utils/index';
import {environment} from "@env";
import {logger} from "@services/logger/logger.service";
import {IQuickAction} from "@core/base/chat-setting-base";
import { coreCrypto } from "@core/r2";
import { BaseHost } from "@core/shared/office-hosts/base-host";
import { IOfficeHost } from "@core/shared/office-hosts/office-host.types";
import { DOCUMENT_UID_KEY } from "@core/shared/office-hosts/office-hosts-constants";

export class WordHost extends BaseHost implements IOfficeHost
{
    public override async getDocumentIDAsync(): Promise<string>
    {
        let documentID = Office.context.document.settings.get(DOCUMENT_UID_KEY)

        if (!documentID) {
            documentID = coreCrypto.uuidV4();
            Office.context.document.settings.set(DOCUMENT_UID_KEY, documentID);

            const isSaved = await cmmn.callAsync<boolean>(async (r) => {
                Office.context.document.settings.saveAsync((saveResult: Office.AsyncResult<void>) => {
                    if (saveResult.status == Office.AsyncResultStatus.Failed) {
                        logger.error(`error code: ${saveResult.error.code}, name: ${saveResult.error.name}, message: '${saveResult.error.message}'`);
                        r.next(false);
                    } else {
                        r.next(true);
                    }
                });
            });

            if (!isSaved) {
                documentID = undefined;
            }
        }

        return documentID;
    }

    public override checkSelectable() { return true; }
    public override checkEditable(): boolean { return true; }
    public override checkDocumentReadable(): boolean {return true;}

    public override getQuickActions(): IQuickAction[] {
        return environment.quick_actions.Word;
    }

    public override async setSelectedTextAsync(plainText: string): Promise<void> {
        await Word.run(function (context) {
            const selection = context.document.getSelection();

            selection.insertText(plainText, Word.InsertLocation.start);

            return context.sync()
        });
    }

    public override async getSelectedContentAsync(): Promise<string> {
        let resultStr = '';

        const resultValue = await cmmn.callAsync<boolean>(async (r) => {
            try {
                Office.context.document.getSelectedDataAsync<string>(Office.CoercionType.Text, (asyncResult) => {
                    if (asyncResult.status == Office.AsyncResultStatus.Failed) {
                        logger.error(this, `getSelectedContentAsync() > failed: ${asyncResult.error.message}`);
                        r.next(false);
                    }
                    else {
                        resultStr = asyncResult.value;
                        r.next(true);
                    }
                });
            }
            catch (err) {
                r.next(false);
            }
        });

        if (resultValue) {
            return resultStr;
        }

        return '';
    }

    public override async getDocumentTextAsync(): Promise<string> {
        let docText = '';

        const resultValue = await cmmn.callAsync<boolean>(async (r) => {
            try {
                Office.context.document.getFileAsync(Office.FileType.Text,
                    { sliceSize: environment.limits_bytes.WHOLE_MESSAGE },
                    (asyncResult) => {
                        if (asyncResult.status == Office.AsyncResultStatus.Failed) {
                            logger.error(this, `getFileAsync() > failed: ${asyncResult.error.message}`);
                            return r.next(false);
                        }

                        const docFile = <Office.File>asyncResult.value;
                        docFile.getSliceAsync(0, (sliceResult) => {
                            if (sliceResult.status == Office.AsyncResultStatus.Failed) {
                                logger.error(this, `getSliceAsync() > failed: ${asyncResult.error.message}`);
                                return r.next(false);
                            }

                            docText = <string>sliceResult.value.data;

                            docFile.closeAsync((closeResult) => {
                                if (closeResult.status == Office.AsyncResultStatus.Failed) {
                                    logger.error(this, `closeAsync() > failed: ${asyncResult.error.message}`);
                                    return r.next(false);
                                }
                            })

                            r.next(true);
                        })
                });
            }
            catch (err) {
                r.next(false);
            }
        });

        if (resultValue) {
            return docText;
        }

        return '';
    }
}
